<template>
  <v-form
    ref="setProjectThumbnail"
    v-model="isFormValid"
    class="set-project-thumbnail"
    @submit.prevent="submitForm"
  >
    <object
      :data="fileUrl"
      type="application/pdf"
      width="100%"
      height="500px"
    />
    <label class="input-label mt-4">Wybierz stronę:</label>
    <v-autocomplete
      v-model="chosenPage"
      placeholder="Wybierz stronę"
      :rules="[rules.required, rules.lowerThan(pdfPagesCount+1)]"
      :items="pagesOptions"
      :menu-props="{ 'offset-y': true }"
      v-bind="props.validatedField"
    />
    <v-btn
      class="custom-submit-button mt-2"
      color="primary"
      type="submit"
      :disabled="!isFormValid"
      :loading="isProcessing"
    >
      Ustaw jako miniaturkę
    </v-btn>
  </v-form>
</template>

<script>
import {mapState, mapActions} from 'vuex'
import {PDFDocument} from 'pdf-lib'
import props from '@/helpers/componentsProps.js'
import rules from '@/helpers/validators.js'

export default {
  props: {
    file: {
      type: Object,
      required: true
    },
  },

  data: ()=>({
    isFormValid:true,
    pdfPagesCount: 1,
    chosenPage: 1,
    props,
    rules,
  }),

  computed:{
    ...mapState('project',[
      'project',
      'isProcessing'
    ]),
    fileUrl() {
      return this.file.url
    },
    pagesOptions() {
      return Array.from({length: this.pdfPagesCount}, (_, index) => index + 1)
    }
  },

  async mounted() {
    this.pdfPagesCount = await this.getPagesCount(this.file.url)
  },

  methods: {
    ...mapActions('project', [
      'selectThumbnail'
    ]),
     async getPagesCount(file) {
      const document = await fetch(file).then(res => res.arrayBuffer())
      const pdf = await PDFDocument.load(document)
      return pdf.getPages().length
    },
    submitForm() {
      this.selectThumbnail({type: 'pdf', id: this.file.id, page: this.chosenPage})
    }
  }
}
</script>
